import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import {  IncidentTabsInEventDto, IncidentEventTypeDto, IncidentTabsDto } from '@cradua/data';
import Swal from 'sweetalert2';

@Component({
  selector: 'cradua-incident-tabs-in-event',
  templateUrl: './incident-tabs-in-event.component.html',
  styleUrls: ['./incident-tabs-in-event.component.scss']
})
export class IncidentTabsInEventComponent implements OnChanges {

  incidentTabsInEventForm: FormGroup;
  incidentTabsInEventFormArray: FormGroup;
  control = new FormControl();
  @Input() incidentTabsInEvents: IncidentTabsInEventDto[] = [];
  @Input() eventTypes: IncidentEventTypeDto[] = [];
  @Input() incidentTabs: IncidentTabsDto[] = [];
  @Input() routeAnimationsElements: any;
  @Output() incidentTabsInEvent = new EventEmitter<IncidentTabsInEventDto[]>()
  @Output() deleteIncidentTabsInEventEvent = new EventEmitter<any>()

    selectedIncidentRiskArea: any;
    filteredDelete: Array<any> =[];
    loading = true;
    selectedIndex = null;
    EventName: string;
    TabName: string;
    status: boolean;
    selectedEventTypeId: any;
    filteredIncidenceTabInEventList: Array<any> = [];
    constructor(
     private fb: FormBuilder,
     ) {}

    ngOnChanges() {
      this.createIncidentTabsInEventForm();

    }

    createIncidentTabsInEventForm() {
      this.incidentTabsInEventForm = this.fb.group({
        
        IncidentEventTypeId: this.selectedEventTypeId,
        EventName: [''],
        IncidentTabsId: [''],
        TabName: [''],
        Position: [''],
        id: null
        });
        this.incidentTabsInEventFormArray = this.fb.group({ IncidentTabsInEvents: this.fb.array([])
          });
        this.setIncidentTabsInEvent();
    }

  // method to display IncidentTabsInEvent
  setIncidentTabsInEvent() {
    const control  = this.incidentTabsInEventFormArray.controls.IncidentTabsInEvents as FormArray;
    this.filteredIncidenceTabInEventList.forEach( e => {
      control.push(
        this.fb.group({
          IncidentEventTypeId: e.IncidentEventTypeId,
          EventName: e.EventName,
          IncidentTabsId: e.IncidentTabsId,
          TabName: e.TabName,
          Position: e.Position,
          id: e.id
        })
      );
    });
  }

  // onSelectEventType(id: string) {
  //   this.EventName = this.eventTypes.find(eventType => eventType.id === id)?.EventName || null;

  // }
  onSelectEventType(event: string) {
   
    this.filteredIncidenceTabInEventList = this.incidentTabsInEvents.filter((s) => s.IncidentEventTypeId === event);
    console.log("Checking Event", this.filteredIncidenceTabInEventList, event );
    this.selectedEventTypeId = event;
    const control = this.incidentTabsInEventFormArray.controls.IncidentTabsInEvents as FormArray;

    if (this.filteredIncidenceTabInEventList.length > 0) {
      this.status = true;
      this.clearFormArray(control);
      this.setIncidentTabsInEvent();
    } else {
      this.status = true;
      this.clearFormArray(control);
    }
  }
  onSelectTabs(id: string) {
    this.TabName = this.incidentTabs.find(tab => tab.id === id)?.TabName || null;

  }
  // method to add IncidentRiskArea
  addIncidentTabsInEvent(value: IncidentTabsInEventDto) {
    const control  = this.incidentTabsInEventFormArray.controls.IncidentTabsInEvents as FormArray;
    control.insert(0,
          this.fb.group({
            IncidentEventTypeId: this.selectedEventTypeId,
            EventName: this.EventName,
            IncidentTabsId: value.IncidentTabsId,
            TabName: this.TabName,
            Position: value.Position,
            id: null
          })
       );
  }

  

  // getEventName(id: string) {
  //   const found = this.eventTypes.find(eventype => eventype.id === id);
  //  return found ? found.EventName : '';
  // }
  getTabName(id: string) {
    const found = this.incidentTabs.find(tab => tab.id === id);
   return found ? found.TabName : '';
  }
  // method to delete IncidentTabsInEvent from arrary list
  deleteIncidentTabsInEvent(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it'
    }).then((result) => {
      if (result.value) {
  const control = this.incidentTabsInEventFormArray.controls.IncidentRiskAreas as FormArray;
  control.removeAt(index);
  for ( let i = 0; i < this.incidentTabsInEvents.length; i++) {
      if (i === index) {
        if (value.id !== null) {
          this.filteredDelete.push(this.incidentTabsInEvent[i].id);
         }

      }
    }
  Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.fire(
            'Cancelled',
            'Your imaginary file is safe :)',
            'error'
          );
        }
      });
  }

  addNew(formValue: IncidentTabsInEventDto) {
    if(this.incidentTabsInEventForm.invalid) {
   return Swal.fire(
      'Warning!',
      'Please, you cannot add blank field',
      'warning'
    );
    }
    if(this.selectedIndex != null) {

      this.incidentTabsInEventFormArray.get('IncidentTabsInEvents')['controls'][this.selectedIndex].patchValue({
        // RiskAreaName: formValue.RiskAreaName,
        // RiskAreaDescription: formValue.RiskAreaDescription,
        // IncidentEventTypeId: formValue.IncidentEventTypeId,
        // EventName: this.EventName != null ? this.EventName : formValue.EventName,
       ...formValue
      });
    } else {
      this.addIncidentTabsInEvent(formValue);
    }
    this.selectedIndex = null;
    this.incidentTabsInEventForm.reset()
  }

  onEdit(index, value: IncidentTabsInEventDto) {
    this.selectedIndex = index;
    this.incidentTabsInEventForm.patchValue({...value});
  }

  onClearForm() {
    this.selectedIndex = null;
    this.incidentTabsInEventForm.reset();
  }
  clearFormArray = (formArray: FormArray) => {
    const control = this.incidentTabsInEventFormArray.controls.IncidentTabsInEvents as FormArray;
    while (formArray.length !== 0) {
      control.removeAt(0);
    }
  };

  // onSubmit(formValue: IncidentTabsInEventDto[]) {
  // this.incidentTabsInEvent.emit(formValue);
  // if(this.filteredDelete.length !== 0) {
  //   this.deleteIncidentTabsInEventEvent.emit(this.filteredDelete);
  // }
  // }
  onSubmit(formValue: any) {
    formValue.type = 'incidentTabsInEvent';
    this.incidentTabsInEvent.emit(formValue);
    if (this.filteredDelete.length > 0) {
      this.filteredDelete.unshift('incidentTabsInEvent');
      this.deleteIncidentTabsInEventEvent.emit(this.filteredDelete);
    }
  }

}

